/**
 * Charges décimales (2026-10-25) : 62,5 kg.
 *
 * Les charges étaient des entiers partout. Ici, la lecture d'une saisie (« 62,5 »
 * comme « 62.5 » — `parseFloat` s'arrête à la virgule et lisait 62) et
 * l'affichage dans la langue de l'interface.
 */

/** « 62,5 » ou « 62.5 » → 62.5. NaN si illisible. */
export function lireCharge(saisie: string): number {
  return parseFloat(saisie.trim().replace(',', '.'));
}

/** 60 → « 60 », 62.5 → « 62,5 » (fr) ou « 62.5 » (en), jamais plus de 2 décimales. */
export function formaterKg(valeur: number, langue?: string): string {
  return new Intl.NumberFormat(langue, { maximumFractionDigits: 2 }).format(valeur);
}
